export function currencyFormat(number: number) {
  return Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(number);
}

export function numberFormat(number: number) {
  return Intl.NumberFormat('es-ES', { maximumFractionDigits: 1 }).format(number);
}
